import CouponLogo from 'account/Kupony.svg';
import BonusesLogo from 'account/Bonusy.svg';
import CashbackLogo from 'account/Cashback.svg';
import FreebetsLogo from 'account/Freebet.svg';
import DepositLogo from 'account/Wplata.svg';
import WithdrawLogo from 'account/Wyplata.svg';
import TransferLogo from 'account/Transfery.svg';
import ResponsibleGamingLogo from 'account/OdpowiedzialnaGra.svg';
import LogoutLogo from 'account/Wyloguj.svg';

export default {

    SLIP_HISTORY: { 
        href: '/konto/historia-kuponow',
        translationKey: 'account_userPanel_betHistory',
        file: CouponLogo
    },
    BONUS: {
        href: '/konto/bonus',
        translationKey: 'account_userPanel_bonus',
        file: BonusesLogo
    },
    CASHBACK: {
        href: '/konto/cashback',
        translationKey: 'account_userPanel_cashback',
        file: CashbackLogo
    },
    FREEBETS: {
        href: '/konto/freebety',
        translationKey: 'account_userPanel_coupon',
        file: FreebetsLogo
    },
    DEPOSIT: {
        href: '/konto/wplata',
        translationKey: 'account_userPanel_deposit',
        file: DepositLogo
    },
    WITHDRAW: {
        href: '/konto/wyplata',
        translationKey: 'account_userPanel_withdraw',
        file: WithdrawLogo
    },
    TRANSFER: { 
        href: '/konto/historia-transakcji',
        translationKey: 'account_userPanel_transfer',
        file: TransferLogo
    },
    RESPONSIBLE_GAMING: {
        href: '/konto/odpowiedzialna-gra',
        translationKey: 'account_userPanel_responsibleGaming',
        file: ResponsibleGamingLogo
    },
    LOGOUT: {
        href: '/',  
        translationKey: 'account_userPanel_logout',
        file: LogoutLogo
    }


};